































































import { Component } from 'vue-property-decorator';
import { AppModule } from '@/store/Auth/AppModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PermissionUtils from '@/lib/permissionUtils';
import PermissionType from '@/models/Settings/Roles/PermissionType';

@Component({ name: 'KnowledgeBaseWidget' })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    async openDocs(url: string) {
        await AppModule.openExternalDocumentationURL(url);
    }

    get coreApiSwagger() {
        return AuthModule.me.institution.config.coreApiSwagger;
    }

}
